const colors = {
  black: '#000000',
  white: '#FFFFFF',
  primary: {
    main: '#43253A',
    100: '#f7f7f7',
    150: '#f8f0e5',
    200: '#E7E7E8',
    250: '#C6C6C6',
    300: '#b9b7c3',
    500: '#43253A'
  },
  secondary: {
    main: '#43253A',
    100: '#fcf3eb',
    150: '#fcf3eb',
    175: '#fcf3eb',
    200: '#f9e8d9',
    250: '#f9e8d9',
    300: '#eed2b9',
    400: '#eed0b6',
    500: '#43253A',
    600: '#43253A',
    800: '#43253A'
  },
  gray: {
    50: '#F8F7F6',
    100: '#F3F3F3',
    115: '#E7E7E8',
    125: '#E0E0E0',
    150: '#D0D0D0',
    200: '#C6C6C6',
    225: '#BFBFBF',
    230: '#919191',
    250: '#999999',
    260: '#979797',
    275: '#777777',
    300: '#666666',
    325: '#726B70',
    350: '#707070',
    375: '#5B5B5B',
    400: '#555555',
    425: '#4F4F4F',
    450: '#444444',
    500: '#404040',
    550: '#363636',
    600: '#2D2E2D',
    800: '#222222'
  },
  red: {
    100: '#FAE4E5',
    200: '#771414',
    300: '#A75348',
    400: '#C73D3D',
    500: '#8E0000',
    600: '#9D2D2D',
    700: '#B40000',
    800: '#A82026',
    900: '#A80909'
  },
  blue: {
    main: '#8d9ebc',
    200: '#9192A3',
    300: '#365CFF',
    400: '#6D6E71'
  },
  blackOpacity: {
    10: 'rgba(0, 0, 0, 0.1)',
    16: 'rgba(0, 0, 0, 0.16)'
  },
  whiteOpacity: {
    17: 'rgba(255, 255, 255, 0.17)',
    80: 'rgba(255, 255, 255, 0.80)'
  },
  secondaryOpacity: {
    30: 'rgba(134, 101, 122, 0.3)',
    90: 'rgba(134, 101, 122, 0.9)'
  },
  redOpacity: {
    5: 'rgba(180, 0, 0, 0.05)',
    50: 'rgba(227, 27, 35, 0.5)'
  },
  grayOpacity: {
    90: 'rgba(34, 34, 34, 0.9)'
  }
};

export default colors;
